import { render, staticRenderFns } from "./ChatTypeSwitch.vue?vue&type=template&id=351e74f8&scoped=true&"
import script from "./ChatTypeSwitch.vue?vue&type=script&lang=js&"
export * from "./ChatTypeSwitch.vue?vue&type=script&lang=js&"
import style0 from "./ChatTypeSwitch.vue?vue&type=style&index=0&id=351e74f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351e74f8",
  null
  
)

export default component.exports